export default "__VITE_ASSET__OJ0gkLNV__"